import type { ComponentType } from 'react'
import { useBillingReturn } from './useBillingReturn'
import {
  defaultSettingsSection,
  useSettingsStore,
  type SettingsSection,
} from '@/stores/useSettingsStore'
import { SettingsLayout } from './SettingsLayout'
import { ProfileSection } from './sections/ProfileSection'
import { InvitesSection } from './sections/InvitesSection'
import { BillingsSection } from './sections/BillingsSection'
import { SecuritySection } from './sections/SecuritySection'
import { DeveloperSection } from './sections/DeveloperSection'

/**
 * Every section stays wired up here; which of them a user can select is
 * decided once, in useSettingsStore, from the feature flags.
 */
const SECTION_COMPONENTS: Record<SettingsSection, ComponentType> = {
  profile: ProfileSection,
  invites: InvitesSection,
  billing: BillingsSection,
  security: SecuritySection,
  developer: DeveloperSection,
}

export function SettingsModal() {
  useBillingReturn()
  const { isOpen, activeSection, setSection, close } = useSettingsStore()

  if (!isOpen) return null

  const Section = SECTION_COMPONENTS[activeSection] ?? SECTION_COMPONENTS[defaultSettingsSection]

  return (
    <SettingsLayout activeSection={activeSection} onSectionChange={setSection} onClose={close}>
      <Section />
    </SettingsLayout>
  )
}
